import { module } from 'modujs';
import { html } from '../utils/environment'

const CLASS = {
    PROMO: `has-promo-open`
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        html.classList.add(CLASS.PROMO)
    }

    close() {
        html.classList.remove(CLASS.PROMO)

        setTimeout(() => {
            this.call('update', null, 'Scroll')
        }, 300)
    }
}
